import { createFileRoute } from '@tanstack/react-router'
import { StatsGrid } from '../../../../components/StatsGrid'
import { useStats } from '../../../../hooks/useApi'

export const Route = createFileRoute('/desa/$slug/dashboard/statistik')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    const { data, isLoading } = useStats(desaId)

    return <StatsGrid data={data} isLoading={isLoading} desaId={desaId} />
  },
})
